import { get } from 'lodash';
import { EmailValidation } from 'src/lib/validation/ValidationTypes';
import Schema from 'validate';
import { isDate, isPostalCode } from 'validator';
import isEmail from 'validator/lib/isEmail';

// import schemas
import OrganisationSchema from 'src/lib/paths/organisation_FULL_Paths.json';
let P = OrganisationSchema.attributes;

const mailValidator = (val: string) => isEmail(val);

const OrganisationDataValidator = (orgaDaten: any) => {
	const steuernummer = get(orgaDaten, P.Unternehmensprofil_Steuernummer.path);
	const ustid = get(orgaDaten, P.Unternehmensprofil_U_St_Id_Nr.path);
	const hasSteuerOrUmsatzNummer =
		(typeof steuernummer === 'string' ? steuernummer.trim() !== '' : !!steuernummer) || (typeof ustid === 'string' ? ustid.trim() !== '' : !!ustid);
	const HAS_STEUER_OR_UMSATZ_NUMMER_MESSAGE = 'Bitte geben Sie entweder eine Steuernummer oder eine USt-IdNr. an.';
	const newSchema = new Schema({
		//
		// ORGANISATIONSPROFIL
		//
		[P.Geschaeftsbezogene_Daten_Name_Der_Organisation.path]: {
			type: String,
			required: true,
		},
		[P.Geschaeftsbezogene_Daten_Rechtsform_Der_Organisation.path]: {
			type: String,
		},
		[P.Unternehmensprofil_Gruendungsdatum.path]: {
			use: {
				dateType: (val: any) => {
					try {
						if (val === null || val === undefined) return true;
						if (!isDate(val)) return false;
						return true;
					} catch (error) {
						return false;
					}
				},
			},
			message: {
				dateType: 'Bitte geben Sie ein gültiges Datum ein.',
			},
		},
		[P.Unternehmensprofil_Handelsregisternummer.path]: {
			type: String,
		},
		// [P.Unternehmensprofil_Name_Des_Geschaeftsfuehrers.path]: {
		// 	type: String,
		// 	required: true,
		// },
		// [P.Unternehmensprofil_Oeffentlicher_Auftraggeber.path]: {
		// 	type: Boolean,
		// },
		// [P.Unternehmensprofil_Sektorenauftraggeber.path]: {
		// 	type: Boolean,
		// },
		// [P.Unternehmensprofil_Oe_PNV_Lizenz_Vorhanden.path]: {
		// 	type: Boolean,
		// },
		// [P.Unternehmensprofil_Verpf_0050602990_fuehrung_Von_Ausschreibungen.path]: {
		// 	type: Boolean,
		// },
		[P.Unternehmensprofil_Zeichnungsberechtigte.path]: {
			each: {
				Anrede: {
					type: String,
				},
				Titel: {
					type: String,
				},
				Vorname: {
					type: String,
					required: true,
				},
				Nachname: {
					type: String,
					required: true,
				},
				Funktion: {
					type: String,
				},
				E_45_Mail_45_Adresse: {
					required: true,
					...EmailValidation,
				},
				Telefonnummer: {
					type: String,
					required: true,
					use: {
						phone: (val: string) => /^[0-9\s]*$/.test(val),
					},
					message: {
						phone: 'Diese Telefonnummer ist ungültig. Es sind nur Zahlen und Leerzeichen erlaubt.',
					},
				},
				Abteilung: {
					type: 'string',
				},
			},
		},
		// [P.Unternehmensprofil_Ansprechpartnerin.path]: {
		// 	each: {
		// 		Anrede: {
		// 			type: String,
		// 		},
		// 		Vorname: {
		// 			type: String,
		// 			required: true,
		// 		},
		// 		Nachname: {
		// 			type: String,
		// 			required: true,
		// 		},
		// 		Funktion: {
		// 			type: String,
		// 		},
		// 		E_45_Mail_45_Adresse: {
		// 			required: true,
		// 			...EmailValidation,
		// 		},
		// 		Telefonnummer: {
		// 			type: String,
		// 			required: true,
		// 			use: {
		// 				phone: (val: string) => /^[0-9\s]*$/.test(val),
		// 			},
		// 			message: {
		// 				phone: 'Diese Telefonnummer ist ungültig. Es sind nur Zahlen und Leerzeichen erlaubt.',
		// 			},
		// 		},
		// 		Abteilung: {
		// 			type: 'string',
		// 		},
		// 	},
		// },

		//
		// ADRESSDATEN
		//
		[P.Adressdaten_Strasse_Und_Hausnummer.path]: {
			type: String,
			required: true,
		},
		[P.Adressdaten_Adresszusatz.path]: {
			type: String,
		},
		[P.Adressdaten_PLZ.path]: {
			type: String,
			required: true,
			use: {
				postalCode: (val: string) => isPostalCode(val, 'DE'),
			},
			message: {
				postalCode: 'Diese Postleitzahl ist ungültig.',
			},
		},
		[P.Adressdaten_Ort.path]: {
			type: String,
			required: true,
		},
		[P.Adressdaten_Landkreis_Kreisfreie_Stadt.path]: {
			type: String,
			required: true,
		},

		//
		// KONTAKTDATEN DER ORGANISATION
		//
		[P.Kontaktdaten_E_Mail.path]: {
			type: String,
			required: true,
			use: { mailValidator },
			message: {
				mailValidator: 'Ungültige E-Mail-Adresse.',
			},
		},
		[P.Kontaktdaten_Fax.path]: {
			type: String,
		},
		[P.Kontaktdaten_Telefon.path]: {
			type: String,
			required: true,
			use: {
				phone: (val: string) => /^[0-9\s]*$/.test(val),
			},
			message: {
				phone: 'Diese Telefonnummer ist ungültig. Es sind nur Zahlen und Leerzeichen erlaubt.',
			},
		},
		[P.Kontaktdaten_Webadresse.path]: {
			type: String,
		},

		//
		// MAILBENACHRICHTIGUNGEN
		//
		[P.Mailbenachrichtungen_Mail.path]: {
			each: {
				Mailbenachrichtungen_Mail: {
					type: String,
					required: true,
					use: { mailValidator },
					message: {
						mailValidator: 'Ungültige E-Mail-Adresse.',
					},
				},
			},
		},

		//
		// STEUERINFORMATIONEN
		//
		[P.Unternehmensprofil_Steuernummer.path]: {
			type: String,
			required: !hasSteuerOrUmsatzNummer,
			message: {
				required: HAS_STEUER_OR_UMSATZ_NUMMER_MESSAGE,
			},
		},
		[P.Unternehmensprofil_U_St_Id_Nr.path]: {
			type: String,
			required: !hasSteuerOrUmsatzNummer,
			message: {
				required: HAS_STEUER_OR_UMSATZ_NUMMER_MESSAGE,
			},
		},
		[P.Unternehmensprofil_Angaben_Zum_Vorsteuerabzug.path]: {
			// type: Boolean,
			required: true,
		},
		// [P.Unternehmensprofil_Vorst_0237375484_chtigung_prozentualer_Anteil.path]: {
		// 	use: {
		// 		minMaxValidation: (val: any) => {
		// 			try {
		// 				if (val) return Number(val) >= 0 && Number(val) <= 100;
		// 				else return true;
		// 			} catch (error) {
		// 				return false;
		// 			}
		// 		},
		// 		decimal: (val: any) => {
		// 			try {
		// 				if (val) return isDecimal(val.toString(), { decimal_digits: '0,2' });
		// 				else return true;
		// 			} catch (error) {
		// 				return false;
		// 			}
		// 		},
		// 	},
		// 	message: {
		// 		minMaxValidation: `Der Wert muss zwischen ${DisplayDecimal(0)} und ${DisplayDecimal(100)} sein`,
		// 		decimal: 'Es sind nur 2 Stellen hinter dem Komma erlaubt.',
		// 	},
		// },
		[P.Unternehmensprofil_Wirtschafts_Identifikationsnummer.path]: {
			type: String,
		},
		// ...(isTrue(get(orgaDaten, P.Unternehmensprofil_Vorst_0211241063_Vorsteuerabzugsberechtigung.path)) ?
		// 	{
		// 		[P.Unternehmensprofil_Vorst_0237375484_chtigung_prozentualer_Anteil.path]: {
		// 			required: true,
		// 			...GetMinMaxDecimalValidation(0, 100),
		// 		},
		// 	}
		// :	{}),

		[P.Organisationsprofil_Vollstaendig.path]: {
			type: Boolean,
			required: true,
		},
	});

	newSchema.message({
		required: (_path: string) => 'Pflichtfeld.',
		type: (path: string) => `Das Formular ist fehlerhaft, bitte melden Sie diesen Fehler. Geben Sie als Grund "falscher Datentyp, ${path}" an.`,
	});

	return newSchema;
};

export default OrganisationDataValidator;
